export const NewTaskIcon = (props: any) => (
  <svg
    width={12}
    height={11}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.14.64 1.5 2.298.86 1.64l-.72.718L1.5 3.703 3.86 1.36 3.14.641ZM5 1.5v1h7v-1H5Zm0 4v1h7v-1H5Zm0 4v1h7v-1H5Z"
      fill="#424248"
    />
  </svg>
);

export const NewTaskIconBig = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.42578 0.800781L5.32422 1.69922L2.375 4.62891L0.675781 2.94922L1.57422 2.05078L2.375 2.87109L4.42578 0.800781ZM6.75 1.875H15.5V3.125H6.75V1.875ZM6.75 6.875H15.5V8.125H6.75V6.875ZM6.75 11.875H15.5V13.125H6.75V11.875Z"
      fill="#646363"
    />
  </svg>
);
